export const INFOGRAPH_URL = 'https://infograph.venngage.com';

export const STAGING_INFOGRAPH_URL = 'https://infograph.venngage.beer';

// [Local only] This is e2 api endpoint that only needs for frontend works in local env
export const API_DOMAIN = process.env.REACT_APP_INFOGRAPH_API_DOMAIN;

// [Standalone only] This is e2 api JWT that only needs for standalone env
export const STANDALONE_API_KEY = process.env.REACT_APP_INFOGRAPH_API_KEY;

// A manually created id on the e1 db as a placeholder for the new e2 design.
export const BLANK_TEMPLATE_ID = 'e60ed8c8-bfe3-4282-a13f-00a325749eda';

export const HELP_INFOGRAPH_URL = 'https://help.venngage.com';
